/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Specialists_TitleInputs */

const en_portal_specialists_title = /** @type {(inputs: Portal_Specialists_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find a specialist`)
};

const pl_portal_specialists_title = /** @type {(inputs: Portal_Specialists_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znajdź specjalistę`)
};

/**
* | output |
* | --- |
* | "Find a specialist" |
*
* @param {Portal_Specialists_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_specialists_title = /** @type {((inputs?: Portal_Specialists_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Specialists_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_specialists_title(inputs)
	return en_portal_specialists_title(inputs)
});